import Tooltip from './Tooltip';
import TooltipPassword from './TooltipPassword';

export const TooltipPasswordContent = TooltipPassword;

export default Tooltip;
